"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createFetchRequest_1 = __importDefault(require("./createFetchRequest"));
const beamCreator = (fetchHandler) => class Beam {
    constructor({ tokenBuilder, urlPrefix, directOut } = {}) {
        this.tokenBuilder = tokenBuilder;
        this.urlPrefix = urlPrefix ? urlPrefix : '';
        this.fetchHandler = fetchHandler;
        this.directOut = directOut;
    }
    //Set options
    configure({ tokenBuilder, urlPrefix, directOut }) {
        if (tokenBuilder) {
            this.tokenBuilder = tokenBuilder;
        }
        if (urlPrefix) {
            this.urlPrefix = urlPrefix;
        }
        this.directOut = directOut;
    }
    getToken() {
        if (this.tokenBuilder) {
            return this.tokenBuilder();
        }
        return Promise.reject('No token builder set for this Beam!');
    }
    //FETCH
    fetch({ method, endpoint, body, headers, customConfig }) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, createFetchRequest_1.default)({
                method,
                endpoint,
                body,
                headers,
                customConfig,
                tokenBuilder: this.tokenBuilder,
                urlPrefix: this.urlPrefix,
                fetchHandler: this.fetchHandler,
                directOut: this.directOut
            });
        });
    }
    //GET
    get(endpoint, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetch({
                method: 'GET',
                endpoint,
                headers
            });
        });
    }
    //POST
    post(endpoint, body, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetch({
                method: 'POST',
                endpoint,
                body,
                headers
            });
        });
    }
    //DELETE
    del(endpoint, body, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetch({
                method: 'DELETE',
                endpoint,
                body,
                headers
            });
        });
    }
    //PUT
    put(endpoint, body, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetch({
                method: 'PUT',
                endpoint,
                body,
                headers
            });
        });
    }
    //PATCH
    patch(endpoint, body, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetch({
                method: 'PATCH',
                endpoint,
                body,
                headers
            });
        });
    }
};
exports.default = beamCreator;
//# sourceMappingURL=beamCreator.js.map